import script from "./Appraise.vue?vue&type=script&lang=ts&setup=true"
export * from "./Appraise.vue?vue&type=script&lang=ts&setup=true"

import "./Appraise.vue?vue&type=style&index=0&id=18c7df26&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18c7df26"]])

export default __exports__